import React, {
  useEffect,
  useRef,
  useState,
  createContext,
  useCallback,
  useContext,
} from "react";
import { Model } from "flexlayout-react";
import { StoreContext } from "../../../store/Store";
import { model as dmodel } from "../../../layout/models/relativeperformancemodel";

export const LayoutContext = createContext(undefined);

export const LayoutProvider = ({ children, model }) => {
  const [store] = useContext(StoreContext);
  const { auth } = store;

  const layoutRef = useRef();
  const actionRef = useRef();

  const [state, setState] = useState({ refresh: true });

  const tabExists = useCallback(
    (ticketid) => {
      let i;
      for (i in state.layout.current.tabIds) {
        if (state.layout.current.tabIds[i] === ticketid) {
          return true;
        }
      }
      return false;
    },
    [state.layout]
  );

  const getFirstChild = useCallback(
    (tabsetId) => {
      let component = "";
      let findChild = (obj) => {
        if (obj.id === tabsetId) {
          component = obj.children[0].component;
        } else if (obj.children) {
          obj.children.forEach((item) => findChild(item));
        }
      };
      findChild(state.layout.current.props.model.toJson().layout);

      return component;
    },
    [state.layout]
  );

  const prepareAction = useCallback(
    (tabid) => {
      let isTab = tabExists(tabid);
      const component = isTab
        ? state.layout.current.props.model.getNodeById(tabid)._attributes
            .component
        : getFirstChild(tabid);

      switch (component) {
        case "TableView":
          actionRef.current = {
            isTab,
            tabid,
            component,
            attributes: { tabStripHeight: 6, enableMaximize: false },
          };
          break;
        case "Controls":
          actionRef.current = {
            isTab,
            tabid,
            component,
            attributes: { tabStripHeight: 6, enableMaximize: false },
          };
          break;
        default:
          actionRef.current = {
            isTab,
            tabid,
            component,
            attributes: { enableMaximize: false },
          };
      }
    },
    [state.layout, tabExists, getFirstChild]
  );

  const prepareActionRef = useRef(prepareAction);
  prepareActionRef.current = prepareAction;

  useEffect(() => {
    if (auth) {
      const asyncfunction = async () => {
        // const res = await getLayouts(auth, "default");
        // const model = JSON.parse(res.Item.layout);
        const defaultState = {
          model: Model.fromJson(model ? model : dmodel),
          layout: layoutRef,
          actionRef: actionRef,
          actions: {
            prepareAction: (...args) => prepareActionRef.current(...args),
          },
        };
        setState(defaultState);
      };
      asyncfunction();
    }
  }, [auth, model]);

  return state ? (
    <LayoutContext.Provider value={[state, setState]}>
      {children}
    </LayoutContext.Provider>
  ) : null;
};
